<template>
  <v-container fluid grid-list-md class="mt-4" v-if="hasAdminAny">
    <v-row :class="{ 'mt-1': $vuetify.breakpoint.mdAndDown }">
      <v-col v-if="$vuetify.breakpoint.mdAndDown" sm="12">
        <template v-for="item in filteredMenuItems" :items="filteredMenuItems">
          <v-btn color="primary" x-small text :to="{ name: item.name }" :data-cy="item.dataCy"
            ><v-icon class="mr-2" x-small>{{ item.icon }}</v-icon>
            {{ item.title }}
          </v-btn>
        </template>
      </v-col>
      <v-col v-else sm="2">
        <admin-nav :menuItems="filteredMenuItems"></admin-nav>
      </v-col>
      <v-col cols="12" :sm="$vuetify.breakpoint.mdAndDown ? 12 : 10">
        <div :class="{ 'pr-8 py-10': !$vuetify.breakpoint.mdAndDown }">
          <router-view></router-view>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AdminNav from "./AdminNav";

export default {
  components: { AdminNav },
  computed: {
    filteredMenuItems() {
      const filteredItems = this.menuItems.filter(item => {
        if (!!item.hasFlag) {
          return this[item.flag] && this[item.permission];
        }

        return this[item.permission];
      });
      return filteredItems;
    },
    memberTaggingFlag() {
      return this.flagMap.memberTagging;
    },
    ...mapGetters({
      flagMap: "featureFlag/getFlagMap",
      hasAdminOchin: "session/hasAdminOchin",
      hasAdminAny: "session/hasAdminAny",
      hasAdminOrganization: "session/hasAdminOrganization",
    }),
  },
  props: {
    menuItems: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
};
</script>
